const GlobalConsts = {
    DARK: 'dark',
    LIGHT: 'light',
};

export default GlobalConsts;